// @ts-nocheck
import React from 'react';
import { Row,Button,Dropdown,Menu} from "antd";
import styled from "styled-components";
import { Capitalize } from '../../look';
import dropdown_Arrow from '../../assets/dropdown_Arrow.svg'
import dropdown_arrow from '../../assets/one-on-one-dropdown-arrow.svg'
const EmployeeFilterForFeedbacks = props => {
   
    


    
    const {setActiveFilter,allMeetingMembers,setSelectedEmp,activeFilter} = props
    const [selectedFilter,setFilter]=React.useState()
    React.useEffect(()=>{

        if(activeFilter === "All"){
            setFilter(undefined)
        }

    },[activeFilter])
  

    const Filtermenu =()=> (
        <Menu  style={{maxHeight:'200px',overflow:'auto'}} suffixIcon={<img src={dropdown_Arrow} alt="" style={{width:"10px",height:"10px"}}/>}>
          {
            allMeetingMembers && (
                allMeetingMembers?.map((data)=>
                    <Menu.Item key={data?.id} onClick={()=>{setFilter(data);setSelectedEmp(data?.id);}} >
                        {Capitalize(data?.user?.firstName)} {Capitalize(data?.user?.lastName)}
                    </Menu.Item>
                )
            )
          }
        </Menu>
        
      );

      
    return (
        <>
            <Row style={{flexWrap:"nowrap"}} onClick={(e)=>setActiveFilter('EmpDropDown')}>
                <Dropdown overlay={Filtermenu}>
                    <DropdownButton>
                        <div style={{width:'100%',overflow:'hidden',textOverflow:'ellipsis',textAlign:'left'}}>
                            {selectedFilter? `${Capitalize(selectedFilter?.user?.firstName)} ${Capitalize(selectedFilter?.user?.lastName)}`:"Select One"}
                            </div>
                        <img src={dropdown_arrow} alt="" />
                    </DropdownButton>
                </Dropdown>
            </Row>
        </>
    )

}

export default  EmployeeFilterForFeedbacks;

const DropdownButton = styled(Button)`
width:100px;
display:flex;
height:36px;
justify-content:space-between;
align-items:center;
gap:5px
`